
import {
  FaHome,
  FaUser,
  FaCog,
  FaEnvelope,
  FaHeart,
  FaStar,
  FaCalendarAlt,
  FaCamera,
  FaMusic,
  FaLightbulb,
  FaShoppingCart,
  FaBookmark,
  FaRoute,
  FaCompass,
  FaClock,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaWifi,
  FaMap,
  FaPaw,
  FaBed,
  FaBath,
  FaShower,
  FaCouch,
  FaTv,
  FaTemperatureHigh,
  FaFan,
  FaFireExtinguisher,
  FaFirstAid,
  FaDoorOpen,
  FaKey,
  FaLock,
  FaCoffee,
  FaUtensils,
  FaWineGlass,
  FaTshirt,
  FaWater,
  FaHotTub,
  FaSwimmingPool,
  FaCar,
  FaWheelchair,
  FaBaby,
  FaDog,
  FaCat,
  FaSmokingBan,
  FaBroom,
  FaTrash,
  FaRecycle,
  FaPlug,
  FaChargingStation,
  FaTools,
  FaTree,
  FaBicycle,
  FaBus,
  FaTrain,
  FaPlane,
  FaTaxi,
  FaWalking,
  FaRunning,
  FaHiking,
  FaDumbbell,
  FaSwimmer,
  FaFootballBall,
  FaBasketballBall,
  FaBaseballBall,
  FaVolleyballBall,
  FaTableTennis,
  FaGamepad,
  FaLaptop,
  FaMobileAlt,
  FaTabletAlt,
  FaHeadphones,
  FaMicrophone,
  FaVideo,
  FaPlay,
  FaPause,
  FaStop,
  FaVolumeUp,
  FaVolumeMute,
  FaSun,
  FaMoon,
  FaCloud,
  FaCloudRain,
  FaCloudSun,
  FaSnowflake,
  FaBolt,
  FaUmbrella,
  FaThermometerHalf,
  FaBeer,
  FaPizzaSlice,
  FaHamburger,
  FaIceCream,
  FaAppleAlt,
  FaCarrot,
  FaBreadSlice,
  FaFish,
  FaEgg,
  FaShoppingBag,
  FaStore,
  FaTag,
  FaGift,
  FaTruck,
  FaWrench,
  FaHammer,
  FaPaintBrush,
  FaBatteryFull,
  FaUnlock,
  FaShieldAlt,
  FaExclamationTriangle,
  FaInfoCircle,
  FaQuestionCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaSearch,
  FaFilter,
  FaSort,
  FaPlusCircle,
  FaMinusCircle,
  FaEdit,
  FaSave,
  FaDownload,
  FaUpload,
  FaShareAlt,
  FaLink,
  FaGlobe,
  FaLanguage,
  FaChartBar,
  FaChartLine,
  FaClipboardList,
  FaFileAlt,
  FaFolderOpen,
  FaStickyNote,
  FaPen,
  FaPaperclip,
  FaPrint,
  FaBell,
  FaBellSlash,
  FaCommentDots,
  FaComments,
  FaUsers,
  FaUserFriends,
  FaIdCard,
  FaBriefcase,
  FaGraduationCap,
  FaBook,
  FaBookOpen,
  FaHospital,
  FaMedkit,
  FaStethoscope,
  FaHeartbeat,
  FaLeaf,
  FaSeedling,
  FaFire,
  FaMountain,
  FaCampground,
  FaBinoculars,
  FaBox,
  FaBoxOpen,
  FaCubes,

  FaBan,
  FaUserCheck,
  FaUserPlus,
  FaUserSlash,
  FaSoap,
  FaCouch as FaFurniture,
  FaGavel,
  FaBullhorn,
  FaShoePrints,
  FaBalanceScale,
  FaChild,
  FaDoorClosed,
  FaCity,
  FaWarehouse
} from 'react-icons/fa';

import { PiHairDryer } from "react-icons/pi";
import { MdBalcony } from "react-icons/md";
import { FaBuilding as FaBuilding6} from "react-icons/fa6";
import { GiPartyPopper } from "react-icons/gi";
import IconHouse from '../components/IconHouse/IconHouse';
import IconStudio from '../components/IconStudio/IconStudio';
import {
  IconAirPurifier,
  IconBalcony,
  IconCouch,
  IconDishwasherGen,
  IconHairDryer,
  IconHotelAirConditioner,
  IconHotelLaundry,
  IconIroningStreamlineTabler,
  IconKitchen,
  IconCloset,
  IconMicrowave,
  IconOvenFill,
  IconOvenMitts,
  IconPetPaw,
  IconRefrigerator,
  IconShower,
  IconSmartToilet,
  IconSofa,
  IconTv,
  IconWifi,
} from '../components';


export const selectableIcons = [
  // ===== Amenities / Home =====
  {
    id: 'bed',
    name: 'bed bedroom sleep mattress room',
    icon: FaBed,
    category: 'amenities',
    description: 'Bed / bedroom',
  },
  {
    id: 'bath',
    name: 'bath bathroom tub bathtub',
    icon: FaBath,
    category: 'amenities',
    description: 'Bathroom / bathtub',
  },

  {
    id: 'couch',
    name: 'couch sofa living room lounge',
    icon: FaCouch,
    category: 'amenities',
    description: 'Sofa / living room',
  },
  {
    id: 'wifi-amenity',
    name: 'wifi internet wireless network',
    icon: FaWifi,
    category: 'amenities',
    description: 'Wi-Fi / internet',
  },
  {
    id: 'ac',
    name: 'air conditioning ac cooling',
    icon: IconHotelAirConditioner,
    category: 'amenities',
    description: 'Air conditioning',
  },
  {
    id: 'heat',
    name: 'heating heater warm temperature',
    icon: FaTemperatureHigh,
    category: 'amenities',
    description: 'Heating',
  },
  {
    id: 'fan',
    name: 'fan ventilation air breeze',
    icon: FaFan,
    category: 'amenities',
    description: 'Fan / ventilation',
  },
  {
    id: 'kitchen',
    name: 'kitchen cooking utensils dinner',
    icon: FaUtensils,
    category: 'amenities',
    description: 'Kitchen / cooking',
  },
  {
    id: 'coffee-maker',
    name: 'coffee maker coffee machine cafe',
    icon: FaCoffee,
    category: 'amenities',
    description: 'Coffee maker',
  },
  {
    id: 'bar-drinks',
    name: 'bar drinks wine glass',
    icon: FaWineGlass,
    category: 'amenities',
    description: 'Bar / drinks',
  },
  {
    id: 'laundry',
    name: 'laundry washing clothes tshirt',
    icon: IconHotelLaundry,
    category: 'amenities',
    description: 'Laundry / washing',
  },
  {
    id: 'hot-water',
    name: 'hot water water heater boiler',
    icon: FaWater,
    category: 'amenities',
    description: 'Hot water',
  },
  {
    id: 'hot-tub',
    name: 'hot tub jacuzzi spa',
    icon: FaHotTub,
    category: 'amenities',
    description: 'Hot tub / jacuzzi',
  },
  {
    id: 'pool',
    name: 'pool swimming pool water',
    icon: FaSwimmingPool,
    category: 'amenities',
    description: 'Swimming pool',
  },
  {
    id: 'elevator',
    name: 'elevator lift building access',
    icon: FaDoorOpen,
    category: 'amenities',
    description: 'Elevator / access',
  },
  {
    id: 'accessible',
    name: 'accessible wheelchair access step free',
    icon: FaWheelchair,
    category: 'amenities',
    description: 'Accessible / wheelchair friendly',
  },
  {
    id: 'family-friendly',
    name: 'family kids baby friendly',
    icon: FaBaby,
    category: 'amenities',
    description: 'Family friendly',
  },
  {
    id: 'no-smoking',
    name: 'no smoking smoke free',
    icon: FaSmokingBan,
    category: 'amenities',
    description: 'No smoking',
  },
  {
    id: 'security-camera',
    name: 'security camera surveillance outdoor',
    icon: FaCamera,
    category: 'amenities',
    description: 'Security camera',
  },
  {
    id: 'security-door',
    name: 'security lock safe door key',
    icon: FaLock,
    category: 'amenities',
    description: 'Secure lock / door',
  },
  {
    id: 'key-access',
    name: 'key access entry self check in',
    icon: FaKey,
    category: 'amenities',
    description: 'Key access / self check-in',
  },
  {
    id: 'smoke-alarm',
    name: 'smoke alarm fire safety alert',
    icon: FaBell,
    category: 'amenities',
    description: 'Smoke alarm',
  },
  {
    id: 'fire-extinguisher',
    name: 'fire extinguisher safety emergency',
    icon: FaFireExtinguisher,
    category: 'amenities',
    description: 'Fire extinguisher',
  },
  {
    id: 'first-aid',
    name: 'first aid kit medical emergency',
    icon: FaFirstAid,
    category: 'amenities',
    description: 'First aid kit',
  },
  {
    id: 'cleaning',
    name: 'cleaning broom housekeeping',
    icon: FaBroom,
    category: 'amenities',
    description: 'Cleaning / housekeeping',
  },
  {
    id: 'trash-service',
    name: 'trash garbage bin disposal',
    icon: FaTrash,
    category: 'amenities',
    description: 'Trash / disposal',
  },
  {
    id: 'recycling',
    name: 'recycling recycle eco friendly',
    icon: FaRecycle,
    category: 'amenities',
    description: 'Recycling',
  },
  {
    id: 'charging',
    name: 'charging outlets power plug',
    icon: FaPlug,
    category: 'amenities',
    description: 'Power outlets / charging',
  },
  {
    id: 'ev-charging',
    name: 'ev charging electric car station',
    icon: FaChargingStation,
    category: 'amenities',
    description: 'EV charging',
  },
  {
    id: 'tools-maintenance',
    name: 'tools maintenance repair handyman',
    icon: FaTools,
    category: 'amenities',
    description: 'Tools / maintenance',
  },
  {
    id: 'location',
    name: 'location address map pin nearby',
    icon: FaMapMarkerAlt,
    category: 'amenities',
    description: 'Location / nearby',
  },
  {
    id: 'garden',
    name: 'garden yard outdoor tree',
    icon: FaTree,
    category: 'amenities',
    description: 'Garden / outdoor area',
  },

  // ===== Base / Common =====
  {
    id: 'home',
    name: 'home house start main',
    icon: FaHome,
    category: 'navigation',
    description: 'Home / house icon',
  },
  {
    id: 'user',
    name: 'user profile person account',
    icon: FaUser,
    category: 'people',
    description: 'User / profile icon',
  },
  {
    id: 'settings',
    name: 'settings gear options preferences',
    icon: FaCog,
    category: 'system',
    description: 'Settings / gear icon',
  },
  {
    id: 'mail',
    name: 'mail email message envelope',
    icon: FaEnvelope,
    category: 'communication',
    description: 'Email / envelope icon',
  },
  {
    id: 'heart',
    name: 'heart favorite like love',
    icon: FaHeart,
    category: 'social',
    description: 'Heart / favorite icon',
  },
  {
    id: 'star',
    name: 'star rating favorite featured',
    icon: FaStar,
    category: 'social',
    description: 'Star / rating icon',
  },
  {
    id: 'calendar',
    name: 'calendar date event schedule',
    icon: FaCalendarAlt,
    category: 'productivity',
    description: 'Calendar / date icon',
  },
  {
    id: 'clock',
    name: 'clock time hour schedule',
    icon: FaClock,
    category: 'time',
    description: 'Clock / time icon',
  },
  {
    id: 'bookmark',
    name: 'bookmark save favorite mark',
    icon: FaBookmark,
    category: 'utilities',
    description: 'Bookmark / save icon',
  },
  {
    id: 'music',
    name: 'music song audio sound',
    icon: FaMusic,
    category: 'media',
    description: 'Music / audio icon',
  },
  {
    id: 'cart',
    name: 'cart shopping buy store checkout',
    icon: FaShoppingCart,
    category: 'shopping',
    description: 'Shopping cart icon',
  },

  // Shopping
  {
    id: 'shopping-bag',
    name: 'shopping bag retail purchase',
    icon: FaShoppingBag,
    category: 'shopping',
    description: 'Shopping bag icon',
  },
  {
    id: 'store',
    name: 'store shop market retail',
    icon: FaStore,
    category: 'shopping',
    description: 'Store / shop icon',
  },
  {
    id: 'tag',
    name: 'tag label price sale',
    icon: FaTag,
    category: 'shopping',
    description: 'Tag / label icon',
  },
  {
    id: 'gift',
    name: 'gift present surprise reward',
    icon: FaGift,
    category: 'shopping',
    description: 'Gift / present icon',
  },

  // Communication / location
  {
    id: 'phone',
    name: 'phone call contact mobile',
    icon: FaPhoneAlt,
    category: 'communication',
    description: 'Phone / call icon',
  },
  {
    id: 'map',
    name: 'map navigation directions route',
    icon: FaMap,
    category: 'location',
    description: 'Map icon',
  },
  {
    id: 'globe',
    name: 'globe world web internet',
    icon: FaGlobe,
    category: 'technology',
    description: 'Globe / web icon',
  },
  {
    id: 'link',
    name: 'link url connect chain',
    icon: FaLink,
    category: 'technology',
    description: 'Link / URL icon',
  },

  // Devices / media controls
  {
    id: 'laptop',
    name: 'laptop computer work device',
    icon: FaLaptop,
    category: 'technology',
    description: 'Laptop icon',
  },
  {
    id: 'mobile',
    name: 'mobile phone smartphone device',
    icon: FaMobileAlt,
    category: 'technology',
    description: 'Mobile / smartphone icon',
  },
  {
    id: 'tablet',
    name: 'tablet device ipad',
    icon: FaTabletAlt,
    category: 'technology',
    description: 'Tablet icon',
  },

  {
    id: 'headphones',
    name: 'headphones audio music listen',
    icon: FaHeadphones,
    category: 'media',
    description: 'Headphones icon',
  },
  {
    id: 'microphone',
    name: 'microphone mic voice record',
    icon: FaMicrophone,
    category: 'media',
    description: 'Microphone icon',
  },
  {
    id: 'video',
    name: 'video camera film record',
    icon: FaVideo,
    category: 'media',
    description: 'Video / camera icon',
  },
  {
    id: 'play',
    name: 'play start media',
    icon: FaPlay,
    category: 'media',
    description: 'Play icon',
  },
  {
    id: 'pause',
    name: 'pause stop hold',
    icon: FaPause,
    category: 'media',
    description: 'Pause icon',
  },
  {
    id: 'stop',
    name: 'stop end media',
    icon: FaStop,
    category: 'media',
    description: 'Stop icon',
  },
  {
    id: 'volume-up',
    name: 'volume sound audio loud',
    icon: FaVolumeUp,
    category: 'media',
    description: 'Volume up icon',
  },
  {
    id: 'volume-mute',
    name: 'mute volume silent',
    icon: FaVolumeMute,
    category: 'media',
    description: 'Mute / silent icon',
  },

  // Pets
  {
    id: 'dog',
    name: 'dog pet puppy animal',
    icon: FaDog,
    category: 'pets',
    description: 'Dog icon',
  },
  {
    id: 'cat',
    name: 'cat pet kitten animal',
    icon: FaCat,
    category: 'pets',
    description: 'Cat icon',
  },
  {
    id: 'paw',
    name: 'paw pet footprint animal',
    icon: FaPaw,
    category: 'pets',
    description: 'Paw / pet icon',
  },

  // Transport / activity
  {
    id: 'car',
    name: 'car drive vehicle auto',
    icon: FaCar,
    category: 'transport',
    description: 'Car icon',
  },
  {
    id: 'bicycle',
    name: 'bicycle bike ride cycling',
    icon: FaBicycle,
    category: 'transport',
    description: 'Bicycle icon',
  },
  {
    id: 'bus',
    name: 'bus public transport travel',
    icon: FaBus,
    category: 'transport',
    description: 'Bus icon',
  },
  {
    id: 'train',
    name: 'train subway rail transport',
    icon: FaTrain,
    category: 'transport',
    description: 'Train icon',
  },
  {
    id: 'plane',
    name: 'plane flight travel airport',
    icon: FaPlane,
    category: 'transport',
    description: 'Airplane icon',
  },
  {
    id: 'taxi',
    name: 'taxi cab ride transport',
    icon: FaTaxi,
    category: 'transport',
    description: 'Taxi icon',
  },
  {
    id: 'party',
    name: 'party loud event',
    icon: GiPartyPopper,
    category: 'event',
    description: 'Party icon',
  },
  {
    id: 'walking',
    name: 'walking walk steps stroll',
    icon: FaWalking,
    category: 'activity',
    description: 'Walking icon',
  },
  {
    id: 'running',
    name: 'running jog fitness cardio',
    icon: FaRunning,
    category: 'activity',
    description: 'Running icon',
  },
  {
    id: 'hiking',
    name: 'hiking trail outdoors walk',
    icon: FaHiking,
    category: 'activity',
    description: 'Hiking icon',
  },
  {
    id: 'dumbbell',
    name: 'gym dumbbell workout fitness',
    icon: FaDumbbell,
    category: 'activity',
    description: 'Workout / dumbbell icon',
  },
  {
    id: 'swim',
    name: 'swim swimming pool water',
    icon: FaSwimmer,
    category: 'activity',
    description: 'Swimming icon',
  },

  // Sports
  {
    id: 'football',
    name: 'football soccer sports ball',
    icon: FaFootballBall,
    category: 'sports',
    description: 'Football / soccer icon',
  },
  {
    id: 'basketball',
    name: 'basketball sports ball',
    icon: FaBasketballBall,
    category: 'sports',
    description: 'Basketball icon',
  },
  {
    id: 'baseball',
    name: 'baseball sports ball',
    icon: FaBaseballBall,
    category: 'sports',
    description: 'Baseball icon',
  },
  {
    id: 'volleyball',
    name: 'volleyball sports ball',
    icon: FaVolleyballBall,
    category: 'sports',
    description: 'Volleyball icon',
  },
  {
    id: 'pingpong',
    name: 'table tennis ping pong',
    icon: FaTableTennis,
    category: 'sports',
    description: 'Table tennis icon',
  },
  {
    id: 'gamepad',
    name: 'game gaming controller play',
    icon: FaGamepad,
    category: 'leisure',
    description: 'Game controller icon',
  },

  // Weather
  {
    id: 'sun',
    name: 'sun sunny day weather',
    icon: FaSun,
    category: 'weather',
    description: 'Sunny / sun icon',
  },
  {
    id: 'moon',
    name: 'moon night sleep dark',
    icon: FaMoon,
    category: 'weather',
    description: 'Moon / night icon',
  },
  {
    id: 'cloud',
    name: 'cloud weather sky',
    icon: FaCloud,
    category: 'weather',
    description: 'Cloud icon',
  },
  {
    id: 'cloud-rain',
    name: 'rain rainy cloud weather',
    icon: FaCloudRain,
    category: 'weather',
    description: 'Rain cloud icon',
  },
  {
    id: 'cloud-sun',
    name: 'partly cloudy sun cloud',
    icon: FaCloudSun,
    category: 'weather',
    description: 'Partly cloudy icon',
  },
  {
    id: 'snow',
    name: 'snow cold winter weather',
    icon: FaSnowflake,
    category: 'weather',
    description: 'Snowflake icon',
  },
  {
    id: 'bolt',
    name: 'storm lightning thunder',
    icon: FaBolt,
    category: 'weather',
    description: 'Lightning / storm icon',
  },
  {
    id: 'umbrella',
    name: 'umbrella rain protection',
    icon: FaUmbrella,
    category: 'weather',
    description: 'Umbrella icon',
  },
  {
    id: 'thermometer',
    name: 'thermometer temperature hot cold',
    icon: FaThermometerHalf,
    category: 'weather',
    description: 'Thermometer icon',
  },

  // Food
  {
    id: 'utensils',
    name: 'food eat restaurant utensils',
    icon: FaUtensils,
    category: 'food',
    description: 'Food / utensils icon',
  },
  {
    id: 'coffee',
    name: 'coffee cafe drink mug',
    icon: FaCoffee,
    category: 'food',
    description: 'Coffee icon',
  },
  {
    id: 'beer',
    name: 'beer drink bar',
    icon: FaBeer,
    category: 'food',
    description: 'Beer icon',
  },
  {
    id: 'pizza',
    name: 'pizza slice food',
    icon: FaPizzaSlice,
    category: 'food',
    description: 'Pizza slice icon',
  },
  {
    id: 'burger',
    name: 'burger hamburger food',
    icon: FaHamburger,
    category: 'food',
    description: 'Hamburger icon',
  },
  {
    id: 'ice-cream',
    name: 'ice cream dessert sweet',
    icon: FaIceCream,
    category: 'food',
    description: 'Ice cream icon',
  },
  {
    id: 'apple',
    name: 'apple fruit healthy food',
    icon: FaAppleAlt,
    category: 'food',
    description: 'Apple / fruit icon',
  },
  {
    id: 'carrot',
    name: 'carrot vegetable healthy food',
    icon: FaCarrot,
    category: 'food',
    description: 'Carrot icon',
  },
  {
    id: 'bread',
    name: 'bread bakery food',
    icon: FaBreadSlice,
    category: 'food',
    description: 'Bread icon',
  },
  {
    id: 'fish',
    name: 'fish seafood food',
    icon: FaFish,
    category: 'food',
    description: 'Fish icon',
  },
  {
    id: 'egg',
    name: 'egg breakfast food',
    icon: FaEgg,
    category: 'food',
    description: 'Egg icon',
  },

  // Tools / Home stuff
  {
    id: 'tools',
    name: 'tools fix repair hardware',
    icon: FaTools,
    category: 'home',
    description: 'Tools icon',
  },
  {
    id: 'wrench',
    name: 'wrench repair fix',
    icon: FaWrench,
    category: 'home',
    description: 'Wrench icon',
  },
  {
    id: 'hammer',
    name: 'hammer build construction',
    icon: FaHammer,
    category: 'home',
    description: 'Hammer icon',
  },
  {
    id: 'paint-brush',
    name: 'paint brush design art',
    icon: FaPaintBrush,
    category: 'home',
    description: 'Paint brush icon',
  },
  {
    id: 'broom',
    name: 'broom clean cleaning',
    icon: FaBroom,
    category: 'home',
    description: 'Broom / cleaning icon',
  },
  {
    id: 'trash',
    name: 'trash delete remove bin',
    icon: FaTrash,
    category: 'home',
    description: 'Trash / bin icon',
  },
  {
    id: 'recycle',
    name: 'recycle eco environment',
    icon: FaRecycle,
    category: 'home',
    description: 'Recycle icon',
  },
  {
    id: 'battery',
    name: 'battery power energy charge',
    icon: FaBatteryFull,
    category: 'technology',
    description: 'Battery icon',
  },

  // Safety / UI
  {
    id: 'lock',
    name: 'lock secure privacy',
    icon: FaLock,
    category: 'security',
    description: 'Lock icon',
  },
  {
    id: 'unlock',
    name: 'unlock open access',
    icon: FaUnlock,
    category: 'security',
    description: 'Unlock icon',
  },
  {
    id: 'key',
    name: 'key password access',
    icon: FaKey,
    category: 'security',
    description: 'Key icon',
  },
  {
    id: 'shield',
    name: 'shield protection security',
    icon: FaShieldAlt,
    category: 'security',
    description: 'Shield icon',
  },
  {
    id: 'warning',
    name: 'warning alert caution',
    icon: FaExclamationTriangle,
    category: 'status',
    description: 'Warning / caution icon',
  },
  {
    id: 'info',
    name: 'info information details',
    icon: FaInfoCircle,
    category: 'status',
    description: 'Info icon',
  },
  {
    id: 'help',
    name: 'help question support',
    icon: FaQuestionCircle,
    category: 'status',
    description: 'Help / question icon',
  },
  {
    id: 'success',
    name: 'success check done verified',
    icon: FaCheckCircle,
    category: 'status',
    description: 'Success / check icon',
  },
  {
    id: 'error',
    name: 'error close fail x',
    icon: FaTimesCircle,
    category: 'status',
    description: 'Error / close icon',
  },

  // Actions
  {
    id: 'search',
    name: 'search find lookup',
    icon: FaSearch,
    category: 'actions',
    description: 'Search icon',
  },
  {
    id: 'filter',
    name: 'filter refine sort',
    icon: FaFilter,
    category: 'actions',
    description: 'Filter icon',
  },
  {
    id: 'sort',
    name: 'sort order arrange',
    icon: FaSort,
    category: 'actions',
    description: 'Sort icon',
  },
  {
    id: 'add',
    name: 'add plus new create',
    icon: FaPlusCircle,
    category: 'actions',
    description: 'Add / plus icon',
  },
  {
    id: 'remove',
    name: 'remove minus delete',
    icon: FaMinusCircle,
    category: 'actions',
    description: 'Remove / minus icon',
  },
  {
    id: 'edit',
    name: 'edit pencil change',
    icon: FaEdit,
    category: 'actions',
    description: 'Edit icon',
  },
  {
    id: 'save',
    name: 'save disk store',
    icon: FaSave,
    category: 'actions',
    description: 'Save icon',
  },
  {
    id: 'download',
    name: 'download export file',
    icon: FaDownload,
    category: 'actions',
    description: 'Download icon',
  },
  {
    id: 'upload',
    name: 'upload import file',
    icon: FaUpload,
    category: 'actions',
    description: 'Upload icon',
  },
  {
    id: 'share',
    name: 'share send forward',
    icon: FaShareAlt,
    category: 'actions',
    description: 'Share icon',
  },

  // Docs / notes
  {
    id: 'clipboard-list',
    name: 'clipboard checklist tasks list',
    icon: FaClipboardList,
    category: 'productivity',
    description: 'Checklist / clipboard icon',
  },
  {
    id: 'file',
    name: 'file document paper',
    icon: FaFileAlt,
    category: 'files',
    description: 'File / document icon',
  },
  {
    id: 'folder',
    name: 'folder open files directory',
    icon: FaFolderOpen,
    category: 'files',
    description: 'Folder icon',
  },
  {
    id: 'note',
    name: 'note sticky memo reminder',
    icon: FaStickyNote,
    category: 'productivity',
    description: 'Sticky note icon',
  },
  {
    id: 'pen',
    name: 'pen write signature',
    icon: FaPen,
    category: 'productivity',
    description: 'Pen / writing icon',
  },
  {
    id: 'paperclip',
    name: 'paperclip attach attachment',
    icon: FaPaperclip,
    category: 'files',
    description: 'Attachment / paperclip icon',
  },
  {
    id: 'print',
    name: 'print printer paper',
    icon: FaPrint,
    category: 'productivity',
    description: 'Print icon',
  },

  // Notifications / chat
  {
    id: 'bell',
    name: 'bell notification alert',
    icon: FaBell,
    category: 'communication',
    description: 'Notification bell icon',
  },
  {
    id: 'bell-off',
    name: 'bell off mute notifications',
    icon: FaBellSlash,
    category: 'communication',
    description: 'Muted notifications icon',
  },
  {
    id: 'comment',
    name: 'comment message chat reply',
    icon: FaCommentDots,
    category: 'communication',
    description: 'Comment / message icon',
  },
  {
    id: 'comments',
    name: 'comments chat conversation',
    icon: FaComments,
    category: 'communication',
    description: 'Comments / conversation icon',
  },

  // People / work / study
  {
    id: 'users',
    name: 'users group people team',
    icon: FaUsers,
    category: 'people',
    description: 'Users / group icon',
  },
  {
    id: 'friends',
    name: 'friends users group community',
    icon: FaUserFriends,
    category: 'people',
    description: 'Friends / community icon',
  },
  {
    id: 'id-card',
    name: 'id card badge identification',
    icon: FaIdCard,
    category: 'work',
    description: 'ID card icon',
  },
  {
    id: 'briefcase',
    name: 'briefcase work job business',
    icon: FaBriefcase,
    category: 'work',
    description: 'Briefcase icon',
  },
  {
    id: 'graduation',
    name: 'graduation cap study school',
    icon: FaGraduationCap,
    category: 'education',
    description: 'Graduation cap icon',
  },
  {
    id: 'book',
    name: 'book reading study',
    icon: FaBook,
    category: 'education',
    description: 'Book icon',
  },
  {
    id: 'book-open',
    name: 'book open reading learn',
    icon: FaBookOpen,
    category: 'education',
    description: 'Open book icon',
  },

  // Health
  {
    id: 'hospital',
    name: 'hospital clinic medical',
    icon: FaHospital,
    category: 'health',
    description: 'Hospital icon',
  },
  {
    id: 'medkit',
    name: 'medkit first aid health',
    icon: FaMedkit,
    category: 'health',
    description: 'First aid kit icon',
  },
  {
    id: 'stethoscope',
    name: 'stethoscope doctor checkup',
    icon: FaStethoscope,
    category: 'health',
    description: 'Stethoscope icon',
  },
  {
    id: 'heartbeat',
    name: 'heartbeat health pulse fitness',
    icon: FaHeartbeat,
    category: 'health',
    description: 'Heartbeat icon',
  },

  // Nature / outdoors
  {
    id: 'leaf',
    name: 'leaf nature eco green',
    icon: FaLeaf,
    category: 'outdoors',
    description: 'Leaf icon',
  },
  {
    id: 'seedling',
    name: 'seedling plant grow garden',
    icon: FaSeedling,
    category: 'outdoors',
    description: 'Seedling / plant icon',
  },
  {
    id: 'tree',
    name: 'tree forest nature park',
    icon: FaTree,
    category: 'outdoors',
    description: 'Tree icon',
  },
  {
    id: 'water',
    name: 'water drop ocean lake',
    icon: FaWater,
    category: 'outdoors',
    description: 'Water icon',
  },
  {
    id: 'fire',
    name: 'fire flame campfire',
    icon: FaFire,
    category: 'outdoors',
    description: 'Fire / flame icon',
  },
  {
    id: 'mountain',
    name: 'mountain hiking outdoors',
    icon: FaMountain,
    category: 'outdoors',
    description: 'Mountain icon',
  },
  {
    id: 'camp',
    name: 'camp camping tent outdoors',
    icon: FaCampground,
    category: 'outdoors',
    description: 'Camping icon',
  },
  {
    id: 'binoculars',
    name: 'binoculars explore travel view',
    icon: FaBinoculars,
    category: 'outdoors',
    description: 'Binoculars icon',
  },

  // Shipping / misc
  {
    id: 'box',
    name: 'box package delivery',
    icon: FaBox,
    category: 'home',
    description: 'Box / package icon',
  },
  {
    id: 'box-open',
    name: 'box open package unbox',
    icon: FaBoxOpen,
    category: 'home',
    description: 'Open box icon',
  },
  {
    id: 'cubes',
    name: 'cubes blocks items',
    icon: FaCubes,
    category: 'home',
    description: 'Cubes icon',
  },
  {
    id: 'truck',
    name: 'truck delivery shipping',
    icon: FaTruck,
    category: 'home',
    description: 'Truck / delivery icon',
  },
  {
    id: 'language',
    name: 'language translate globe',
    icon: FaLanguage,
    category: 'utilities',
    description: 'Language / translate icon',
  },
  {
    id: 'chart-bar',
    name: 'chart bar analytics stats',
    icon: FaChartBar,
    category: 'analytics',
    description: 'Bar chart icon',
  },
  {
    id: 'chart-line',
    name: 'chart line analytics growth',
    icon: FaChartLine,
    category: 'analytics',
    description: 'Line chart icon',
  },
  {
    id: 'ac',
    name: 'air conditioning ac cooling',
    icon: FaSnowflake,
    category: 'amenities',
    description: 'Air Conditioning',
  },
  {
    id: 'balcony',
    name: 'balcony terrace patio outdoor',
    icon: IconBalcony,
    category: 'amenities',
    description: 'Balcony',
  },
  {
    id: 'wifi',
    name: 'wifi internet wireless network',
    icon: IconWifi,
    category: 'amenities',
    description: 'WiFi',
  },
  {
    id: 'parking',
    name: 'parking car garage spot',
    icon: FaCar,
    category: 'amenities',
    description: 'Parking',
  },
  {
    id: 'washer',
    name: 'washer laundry washing machine',
    icon: IconHotelLaundry,
    category: 'amenities',
    description: 'Washer',
  },
  {
    id: 'dryer',
    name: 'dryer laundry drying machine',
    icon: IconAirPurifier,
    category: 'amenities',
    description: 'Dryer',
  },
  {
    id: 'heating',
    name: 'heating heater warm temperature',
    icon: FaTemperatureHigh,
    category: 'amenities',
    description: 'Heating',
  },
  {
    id: 'kitchen',
    name: 'kitchen cooking utensils',
    icon: FaUtensils,
    category: 'amenities',
    description: 'Kitchen',
  },
  {
    id: 'furnished',
    name: 'furnished furniture couch sofa',
    icon: FaCouch,
    category: 'amenities',
    description: 'Furnished',
  },
  {
    id: 'gym',
    name: 'gym fitness workout dumbbell',
    icon: FaDumbbell,
    category: 'amenities',
    description: 'Gym',
  },
  {
    id: 'pool',
    name: 'pool swimming pool water',
    icon: FaSwimmingPool,
    category: 'amenities',
    description: 'Pool',
  },
  {
    id: 'elevator',
    name: 'elevator lift building access',
    icon: FaDoorOpen,
    category: 'amenities',
    description: 'Elevator',
  },
{
  id: 'house',
  name: 'house home property',
  icon: IconHouse,
  category: 'property_type',
  description: 'House',
},
{
  id: 'apartment',
  name: 'apartment building flat',
  icon: FaBuilding6,
  category: 'property_type',
  description: 'Apartment',
},
{
  id: 'room',
  name: 'Room',
  icon: FaDoorClosed,
  category: 'property_type',
  description: 'Room',
},
{
  id: 'duplex',
  name: 'duplex two floors',
  icon: FaCity,
  category: 'property_type',
  description: 'Duplex',
},
{
  id: 'loft',
  name: 'loft open space warehouse',
  icon: FaWarehouse,
  category: 'property_type',
  description: 'Loft',
},
{
  id: 'studio',
  name: 'studio',
  icon: IconStudio,
  category: 'property_type',
  description: 'Studio',
},
{
  id: 'pet_friendly',
  name: 'pet friendly animals dog cat',
  icon: IconPetPaw,
  category: 'amenities',
  description: 'Pet friendly',
},
{
  id: 'kitchen_supplies',
  name: 'kitchen supplies utensils cookware',
  icon: IconKitchen,
  category: 'amenities',
  description: 'Kitchen supplies',
},
{
  id: 'microwave',
  name: 'microwave oven appliance kitchen',
  icon: IconMicrowave,
  category: 'amenities',
  description: 'Microwave',
},
{
  id: 'kitchen_stove',
  name: 'stove cooktop burner kitchen',
  icon: IconOvenFill,
  category: 'amenities',
  description: 'Kitchen stove',
},
{
  id: 'kitchen_oven',
  name: 'oven baking appliance kitchen',
  icon: IconOvenMitts,
  category: 'amenities',
  description: 'Kitchen oven',
},
{
  id: 'refrigerator',
  name: 'refrigerator fridge cooling appliance',
  icon: IconRefrigerator,
  category: 'amenities',
  description: 'Refrigerator',
},
{
  id: 'dishwasher',
  name: 'dishwasher cleaning kitchen appliance',
  icon: IconDishwasherGen,
  category: 'amenities',
  description: 'Dishwasher',
},
{
  id: 'tv',
  name: 'tv television screen',
  icon: IconTv,
  category: 'media',
  description: 'TV / screen icon',
},
{
  id: 'sofa',
  name: 'sofa couch living room',
  icon: IconSofa,
  category: 'amenities',
  description: 'Sofa',
},
{
  id: 'sofa_bed',
  name: 'sofa bed convertible couch sleep',
  icon: IconCouch,
  category: 'amenities',
  description: 'Sofa-bed',
},
{
  id: 'bidet',
  name: 'bidet bathroom hygiene',
  icon: IconSmartToilet,
  category: 'amenities',
  description: 'Bidet',
},
{
  id: 'shower',
  name: 'shower bathroom hot water',
  icon: IconShower,
  category: 'amenities',
  description: 'Shower',
},
{
  id: 'hairdryer',
  name: 'hairdryer hair dryer bathroom',
  icon: IconHairDryer,
  category: 'amenities',
  description: 'Hairdryer',
},
{
  id: 'ironing_board',
  name: 'ironing board iron laundry',
  icon: IconIroningStreamlineTabler,
  category: 'amenities',
  description: 'Ironing board',
},
{
  id: 'closets_in_room',
  name: 'closet wardrobe storage room',
  icon: IconCloset,
  category: 'amenities',
  description: 'Closets in room',
},

];

export const houseRulesOptions = [
  { id: 'rule-no-smoking', option: 'no_smoking', label: 'No smoking', icon: FaSmokingBan },
  { id: 'rule-no-pets', option: 'no_pets', label: 'No pets', icon: FaPaw },
  { id: 'rule-pets-approval', option: 'pets_with_approval', label: 'Pets allowed with approval', icon: FaUserCheck },
  { id: 'rule-no-parties', option: 'no_parties', label: 'No parties or events', icon: GiPartyPopper },
  { id: 'rule-quiet-hours', option: 'quiet_hours', label: 'Respect quiet hours', icon: FaMoon },
  { id: 'rule-no-loud-noise', option: 'no_loud_music', label: 'No loud noise after 10 PM', icon: FaBullhorn },
  { id: 'rule-registered-guests', option: 'registered_guests_only', label: 'Registered guests only', icon: FaUserCheck },
  { id: 'rule-no-extra-overnight', option: 'no_unapproved_overnight_guests', label: 'No extra overnight guests', icon: FaUserPlus },
  { id: 'rule-no-illegal-activity', option: 'no_illegal_activities', label: 'No illegal activity', icon: FaBan },
  { id: 'rule-no-commercial-use', option: 'no_commercial_use', label: 'No commercial use', icon: FaBriefcase },
  { id: 'rule-respect-neighbors', option: 'respect_neighbors', label: 'Respect neighbors', icon: FaHeart },
  { id: 'rule-keep-tidy', option: 'keep_clean', label: 'Keep the place tidy', icon: FaLightbulb },
  { id: 'rule-no-shoes', option: 'no_shoes_inside', label: 'No shoes indoors', icon: FaShoePrints },
  { id: 'rule-no-moving-furniture', option: 'no_rearranging_furniture', label: 'Do not move furniture', icon: FaCouch },
  { id: 'rule-turn-off', option: 'turn_off_utilities', label: 'Turn off lights/appliances', icon: FaLightbulb },
  { id: 'rule-lock-up', option: 'lock_up', label: 'Lock up when leaving', icon: FaLock },
  { id: 'rule-no-open-flames', option: 'no_open_flames', label: 'No open flames', icon: FaFire },
  { id: 'rule-report-issues', option: 'report_issues', label: 'Report damage/issues ASAP', icon: FaExclamationTriangle },
  { id: 'rule-follow-laws', option: 'follow_local_laws', label: 'Follow local laws', icon: FaBalanceScale },
  { id: 'rule-checkin-checkout', option: 'respect_checkin_checkout', label: 'Respect check-in/out times', icon: FaClock },
  { id: 'rule-no-drugs', option: 'no_drugs', label: 'No drugs', icon: FaBan },
  { id: 'rule-no-weapons', option: 'no_weapons', label: 'No weapons', icon: FaShieldAlt },
  { id: 'rule-do-not-disable-safety', option: 'no_tampering_safety_devices', label: 'Do not disable safety devices', icon: FaBell },
  { id: 'rule-supervise-children', option: 'children_supervised', label: 'Supervise children', icon: FaChild },
];



export const searchIcons = (query) => {
  const lowerQuery = query.toLowerCase();
  return selectableIcons.filter(icon => 
    icon.name.includes(lowerQuery) || 
    icon.category.includes(lowerQuery) ||
    icon.description.toLowerCase().includes(lowerQuery)
  );
};

export const getIconById = (id) => {
  return selectableIcons.find(icon => icon.id === id);
};
